import { addDays, zonedDay } from '../logistics/format.js';

export type DayGroup = 'today' | 'yesterday' | 'earlier';

/**
 * Notifications under their day — Today, Yesterday, Earlier — on the site's
 * clock, in the order given (newest first, as both lists are). The web bell
 * menu and the phone's Notifications screen group by it.
 */
export function byDay<T extends { at: string }>(items: readonly T[], tz: string, now: Date = new Date()): { day: DayGroup; items: T[] }[] {
  const today = zonedDay(now.toISOString(), tz);
  const yesterday = addDays(today, -1);
  const groups: { day: DayGroup; items: T[] }[] = [];
  for (const item of items) {
    const ymd = zonedDay(item.at, tz);
    const day: DayGroup = ymd === today ? 'today' : ymd === yesterday ? 'yesterday' : 'earlier';
    const last = groups[groups.length - 1];
    if (last?.day === day) last.items.push(item);
    else groups.push({ day, items: [item] });
  }
  return groups;
}
